import ClockWidget from '@/views/mission/components/workspace/widgets/ClockWidget.vue'
import TimerWidget from '@/views/mission/components/workspace/widgets/TimerWidget.vue'
import TMinusWidget from '@/views/mission/components/workspace/widgets/TMinusWidget.vue'
import SystemStatsWidget from '@/views/mission/components/workspace/widgets/SystemStatsWidget.vue'
import StreamHealthWidget from '@/views/mission/components/workspace/widgets/StreamHealthWidget.vue'
import AudioLevelsWidget from '@/views/mission/components/workspace/widgets/AudioLevelsWidget.vue'
import NetworkRadarWidget from '@/views/mission/components/workspace/widgets/NetworkRadarWidget.vue'
import NodeReadyWidget from '@/views/mission/components/workspace/widgets/NodeReadyWidget.vue'
import OBSControlWidget from '@/views/mission/components/workspace/widgets/OBSControlWidget.vue'
import ProPresenterWidget from '@/views/mission/components/workspace/widgets/ProPresenterWidget.vue'
import QLCWidget from '@/views/mission/components/workspace/widgets/QLCWidget.vue'
import ResolumeWidget from '@/views/mission/components/workspace/widgets/ResolumeWidget.vue'
import StudioOneWidget from '@/views/mission/components/workspace/widgets/StudioOneWidget.vue'
import ATEMWidget from '@/views/mission/components/workspace/widgets/ATEMWidget.vue'
import ChatWidget from '@/views/mission/components/workspace/widgets/ChatWidget.vue'
import AlertWidget from '@/views/mission/components/workspace/widgets/AlertWidget.vue'
import MacroWidget from '@/views/mission/components/workspace/widgets/MacroWidget.vue'
import EventLogWidget from '@/views/mission/components/workspace/widgets/EventLogWidget.vue'
import YouTubeWidget from '@/views/mission/components/workspace/widgets/YouTubeWidget.vue'
import OBSProgramWidget from '@/views/mission/components/workspace/widgets/OBSProgramWidget.vue'
import { APPEARANCE_FIELDS } from '@/widgets/appearance'

const NODE_FIELD = { key: 'nodeId', label: 'Device', type: 'node' }

export const WIDGET_REGISTRY = {
  clock: {
    component: ClockWidget,
    title: 'Jam',
    defaultSize: { w: 3, h: 2 },
    fields: [
      { key: 'timezone', label: 'Timezone', type: 'text', placeholder: 'Asia/Jakarta' },
      { key: 'format24h', label: '24-hour format', type: 'boolean' },
    ],
  },
  timer: {
    component: TimerWidget,
    title: 'Timer',
    defaultSize: { w: 3, h: 3 },
    fields: [
      { key: 'label', label: 'Label', type: 'text' },
      {
        key: 'mode',
        label: 'Mode',
        type: 'select',
        options: [
          { value: 'countdown', label: 'Countdown' },
          { value: 'stopwatch', label: 'Stopwatch' },
        ],
      },
      { key: 'duration', label: 'Duration (seconds)', type: 'number', min: 1 },
      {
        key: 'useService',
        label: 'Ikuti preset countdown global',
        type: 'boolean',
        default: true,
      },
    ],
  },
  't-minus': {
    component: TMinusWidget,
    title: 'T− Countdown',
    defaultSize: { w: 4, h: 3 },
    minSize: { w: 3, h: 2 },
    fields: [
      { key: 'label', label: 'Label', type: 'text', placeholder: 'Countdown' },
      {
        key: 'mode',
        label: 'Mode',
        type: 'select',
        options: [
          { value: 'duration', label: 'Duration (manual start)' },
          { value: 'wallclock', label: 'Countdown to clock time' },
        ],
      },
      { key: 'duration', label: 'Duration (seconds)', type: 'number', min: 1 },
      { key: 'targetTime', label: 'Target time (HH:MM)', type: 'text', placeholder: '10:00' },
      { key: 'overtime', label: 'Continue as T+ after GO', type: 'boolean' },
      {
        key: 'useService',
        label: 'Ikuti preset countdown global',
        type: 'boolean',
        default: true,
      },
    ],
  },
  'system-stats': {
    component: SystemStatsWidget,
    title: 'System Stats',
    defaultSize: { w: 3, h: 3 },
    minSize: { w: 2, h: 2 },
    fields: [
      NODE_FIELD,
      {
        key: 'metrics',
        label: 'Metrics',
        type: 'checks',
        options: [
          { value: 'cpu', label: 'CPU %' },
          { value: 'memory', label: 'Memory' },
          { value: 'uplink', label: 'Uplink' },
          { value: 'downlink', label: 'Downlink' },
          { value: 'goroutines', label: 'Goroutines' },
        ],
        default: ['cpu', 'memory', 'uplink', 'downlink'],
      },
      { key: 'showCharts', label: 'Line charts', type: 'boolean' },
      { key: 'showTimestamp', label: 'Show last update', type: 'boolean' },
      { key: 'historyPoints', label: 'History points', type: 'number', min: 5 },
    ],
  },
  'stream-health': {
    component: StreamHealthWidget,
    title: 'Stream Health',
    defaultSize: { w: 3, h: 3 },
    minSize: { w: 2, h: 2 },
    fields: [NODE_FIELD],
  },
  'audio-levels': {
    component: AudioLevelsWidget,
    title: 'Audio Levels',
    defaultSize: { w: 2, h: 3 },
    minSize: { w: 1, h: 2 },
    fields: [
      NODE_FIELD,
      { key: 'maxChannels', label: 'Max channels', type: 'number', min: 1, default: 8 },
      { key: 'sources', label: 'Audio sources (empty = all)', type: 'audio-sources' },
    ],
  },
  'network-radar': {
    component: NetworkRadarWidget,
    title: 'Network Radar',
    defaultSize: { w: 3, h: 4 },
    minSize: { w: 2, h: 3 },
    fields: [
      { key: 'nodeIds', label: 'Devices (empty = all)', type: 'nodes' },
    ],
  },
  'node-ready': {
    component: NodeReadyWidget,
    title: 'Station GO',
    defaultSize: { w: 3, h: 3 },
    minSize: { w: 2, h: 2 },
    fields: [
      { key: 'nodeIds', label: 'Devices (empty = all)', type: 'nodes' },
    ],
  },
  'obs-control': {
    component: OBSControlWidget,
    title: 'OBS Control',
    defaultSize: { w: 4, h: 6 },
    minSize: { w: 3, h: 4 },
    fields: [NODE_FIELD],
  },
  propresenter: {
    component: ProPresenterWidget,
    title: 'ProPresenter',
    defaultSize: { w: 4, h: 6 },
    minSize: { w: 3, h: 4 },
    fields: [NODE_FIELD],
  },
  qlc: {
    component: QLCWidget,
    title: 'QLC+',
    defaultSize: { w: 4, h: 5 },
    minSize: { w: 3, h: 3 },
    fields: [
      NODE_FIELD,
      {
        key: 'showButtons',
        label: 'Show QLC buttons',
        type: 'boolean',
        default: true,
      },
      {
        key: 'buttonIds',
        label: 'QLC buttons (empty = all)',
        type: 'qlc-button-ids',
      },
      {
        key: 'showMacros',
        label: 'Show macros',
        type: 'boolean',
        default: false,
      },
      {
        key: 'macroFilter',
        label: 'Macro source',
        type: 'select',
        options: [
          { value: 'qlc', label: 'QLC sequences only' },
          { value: 'all', label: 'All macros' },
        ],
      },
      {
        key: 'macroIds',
        label: 'Macros (empty = all from source)',
        type: 'macro-ids',
      },
      {
        key: 'showGrandMaster',
        label: 'Show Grand Master',
        type: 'boolean',
        default: true,
      },
    ],
  },
  resolume: {
    component: ResolumeWidget,
    title: 'Resolume',
    defaultSize: { w: 4, h: 5 },
    minSize: { w: 3, h: 3 },
    fields: [NODE_FIELD],
  },
  studioone: {
    component: StudioOneWidget,
    title: 'Studio One',
    defaultSize: { w: 3, h: 2 },
    fields: [NODE_FIELD],
  },
  atem: {
    component: ATEMWidget,
    title: 'ATEM Mini',
    defaultSize: { w: 4, h: 5 },
    minSize: { w: 3, h: 4 },
    fields: [NODE_FIELD],
  },
  chat: {
    component: ChatWidget,
    title: 'Chat',
    defaultSize: { w: 3, h: 4 },
    fields: [
      { key: 'target', label: 'Target', type: 'node-or-all' },
    ],
  },
  alert: {
    component: AlertWidget,
    title: 'Alert',
    defaultSize: { w: 4, h: 3 },
    minSize: { w: 3, h: 3 },
    fields: [
      { key: 'target', label: 'Default target', type: 'node-or-all' },
      {
        key: 'shortcuts',
        label: 'Shortcuts',
        type: 'shortcut-list',
      },
    ],
  },
  macro: {
    component: MacroWidget,
    title: 'Macro',
    defaultSize: { w: 4, h: 4 },
    minSize: { w: 3, h: 3 },
    fields: [
      {
        key: 'macroIds',
        label: 'Macros (empty = all)',
        type: 'macro-ids',
      },
    ],
  },
  'event-log': {
    component: EventLogWidget,
    title: 'Event Log',
    defaultSize: { w: 4, h: 4 },
    fields: [NODE_FIELD],
  },
  youtube: {
    component: YouTubeWidget,
    title: 'YouTube Live',
    defaultSize: { w: 6, h: 5 },
    minSize: { w: 2, h: 2 },
    fields: [
      {
        key: 'url',
        label: 'YouTube URL / Video ID / Channel ID',
        type: 'text',
        placeholder: 'https://youtube.com/watch?v=... or live URL',
      },
      { key: 'autoplay', label: 'Autoplay', type: 'boolean' },
      { key: 'muted', label: 'Muted (required for autoplay)', type: 'boolean' },
      {
        key: 'useService',
        label: 'Ikuti preset countdown global',
        type: 'boolean',
        default: true,
      },
    ],
  },
  'obs-program': {
    component: OBSProgramWidget,
    title: 'OBS Program',
    defaultSize: { w: 6, h: 5 },
    minSize: { w: 3, h: 3 },
    fields: [
      NODE_FIELD,
      {
        key: 'deviceName',
        label: 'Camera device name',
        type: 'text',
        placeholder: 'OBS Virtual Camera (Windows/macOS)',
        default: 'OBS Virtual Camera',
      },
    ],
  },
}

export function getWidgetComponent(type) {
  return WIDGET_REGISTRY[type]?.component || null
}

export function getWidgetTitle(type, config = {}, nodes = []) {
  const fallback = WIDGET_REGISTRY[type]?.title || type
  const custom = String(config?.title || '').trim()
  if (custom && custom !== fallback) return custom
  const nodeId = config?.nodeId
  if (nodeId && Array.isArray(nodes) && nodes.length) {
    const node = nodes.find((n) => n.id === nodeId)
    if (node?.name) return node.name
  }
  return fallback
}

export function getWidgetFields(type) {
  return WIDGET_REGISTRY[type]?.fields || []
}

export function getAppearanceFields() {
  return APPEARANCE_FIELDS
}
